/**
 * Represents a HeadingHandler class that handles the visibility
 * of product titles headings based on the window width.
 */
export class HeadingHandler {
  static isOnPage() {
    return $('.js-product-title').length !== 0;
  }

  constructor() {
    this.productIntroHeader =  $('.product-intro-content-header');
    this.addEventListeners();
    this.toggleHeading(); // Initial call to toggleHeading to set the correct heading

  }

  /**
   * Dynamically repositions the product heading element depending on the current
   * viewport width.
   */
  toggleHeading = () => {
    const $window = $(window);
    const $mobileFlag = $('.js-product-title-flag--mobile');
    const $desktopFlag = $('.js-product-title-flag--desktop');

    if ($window.width() < 992) {
      this.productIntroHeader.insertAfter($mobileFlag);
    } else {
      this.productIntroHeader.insertAfter($desktopFlag);
    }
  }

  /**
   * Call toggleHeading on window resize.
   */
  addEventListeners() {
    $(window).on('resize', this.toggleHeading);
  }
}
